angular.module('impactx.cscontract').controller('CSContractModelListForTenderCtrl', [
    '$scope',
    '$redirect',
    '$controller',
    '$routeParams',
    'PartialDialogsService',
    CSContractModelListForTenderCtrl]);

function CSContractModelListForTenderCtrl($scope, $redirect, $controller, $routeParams, PartialDialogsService) {
    var mainCtrl = $controller('CSContractListCtrl', {});
    PartialDialogsService.setCurrentList(PartialDialogsService.TYPE.CONTRACT, 'cscontractmodellist/tender/'+($routeParams.tenderId ? $routeParams.tenderId : 0));
    mainCtrl.meta = {
        rowTemplate: 'modules/cscontract/templates/cscontractlist.row.tmpl.html',
        filtersTemplate: 'modules/cscontract/templates/cscontractlist.filters.tmpl.html',
        endpoint: '/cscontract/model/listfortender',
        ctrl: mainCtrl,
        id: "cscontractmodellistfortender",
        params: {'tenderId': $routeParams.tenderId ? $routeParams.tenderId : 0},
        buttonDefinition: mainCtrl.buttonDefinition,
        excelParams: {
            params: [{param: 'LotId', intValue: 0},
                {param: 'TenderId', intValue: $routeParams.tenderId ? $routeParams.tenderId : 0}]
        },
        isSelectAble: true
    };
    this.getMeta = function ()
    {
        return mainCtrl.meta;
    };
    mainCtrl.contractType = "model";
    $scope.$watch(function() {
        return mainCtrl.contractType;
    }, function(newValue) {
        if(newValue == "basic") {
            $redirect.redirectTo(null, "/cscontractlist/tender/" + $routeParams.tenderId);
        }
    });
}